"use client"

import styled from "@emotion/styled"
import { Breadcrumbs, Typography } from "@mui/material"
import { Link } from "utils"

import { sharedColors } from "./theme/colors"
import { JSX } from "react"

const StyledContainer = styled.div<{ noPadding?: boolean }>`
  padding: ${(props) => (props.noPadding ? "" : "12px 0 ")};
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => (props.noPadding ? "" : "16px 0 ")};
  }
`

const StyledLink = styled.div`
  text-decoration: none;
`

// Updated interface to match the new breadcrumbs object structure
interface CustomBreadcrumbsProps {
  breadcrumbs: {
    selfObject: { title: string; url: string }
    parents: { title: string; url: string; clickable?: boolean }[]
  }
  children?: JSX.Element
  noPadding?: boolean
}

export const CustomBreadcrumbs: React.FC<CustomBreadcrumbsProps> = ({
  breadcrumbs,
  children,
  noPadding,
}) => {
  const { selfObject, parents } = breadcrumbs
  return (
    <StyledContainer noPadding={noPadding}>
      {children}

      <Breadcrumbs separator={"/"} aria-label="מיקומך בדפי האתר">
        {parents.map((item, index) => (
          <StyledLink key={index.toString()}>
            {item.clickable !== false ? (
              <Link
                style={{
                  textDecoration: "none",
                }}
                href={item.url}
              >
                <Typography variant="body3" color={sharedColors.accessibleGray}>
                  {item.title}
                </Typography>
              </Link>
            ) : (
              <Typography variant="body3" color={sharedColors.accessibleGray}>
                {item.title}
              </Typography>
            )}
          </StyledLink>
        ))}
        <Typography
          variant="body3"
          color={sharedColors.black}
          aria-current="page"
        >
          {selfObject.title}
        </Typography>
      </Breadcrumbs>
    </StyledContainer>
  )
}

export default CustomBreadcrumbs
